import script from "./AIAssistantProcessingView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIAssistantProcessingView.vue?vue&type=script&setup=true&lang=ts"

import "./AIAssistantProcessingView.vue?vue&type=style&index=0&id=5210c067&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5210c067"]])

export default __exports__